import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Navbar,
  ListGroup,
  Dropdown,
  Image,
  DropdownButton,
} from "react-bootstrap";
import { useLocation, NavLink, useNavigate } from "react-router-dom";
import { menuList } from "../../helper/constants/menus";
import { useAuth } from "../../hooks/useAuth";
import * as gfun from "../../helper/functions/general-func";
import * as commonAction from "../../redux-store/actions/commonActions";
import * as generateMetaAdsAction from "../../redux-store/actions/generateMetaAdsAction";
import { ConfirmBox } from "./ConfirmBox";

const SidebarMenus = (props) => {
  const dispatch = useDispatch();
  const { user } = useAuth();
  const isMobile = window.outerWidth < 1024;
  const location = useLocation();
  const [viewHeight, setViewHeight] = useState(window.innerHeight - 42);
  const parentMenuId = location.pathname.split("/")[2];
  const [permissionMenuList, setPermissionMenuList] = useState(null);
  const [confirmBox, setConfirmBox] = useState({
    show: false,
    type: "", // "Sitemap" or "MetaAds"
  });
  const stateCommon = useSelector((state) => state.commonReducer);
  const stateGenerateMetaAds = useSelector((state) => state.generateMetaAdsReducer);


  // console.log(user);
  // console.log(menuList, "menuList");

  useEffect(() => {

    let permissionList = null;
    if (user && user.permissions && user.permissions.length) {
      permissionList = user.permissions.filter(
        (permission) => permission.isView
      );
    }
    // console.log(permissionList,'permissionlist');

    if (permissionList && permissionList.length > 0) {
      const filteredMenuItems = gfun.getPermittedMenus(menuList, permissionList);
      setPermissionMenuList(filteredMenuItems);
    }
  }, []);

  // console.log(permissionMenuList, "permissionmenulist");


  const getNavLinkClass = (path) => {
    return location.pathname &&
      (location.pathname?.toLowerCase() === path?.toLowerCase() ||
        parentMenuId?.toLowerCase() == path?.toLowerCase())
      ? "sidebar-item-active"
      : "";
  };

  useEffect(() => {
    setViewHeight(window.innerHeight);
  }, [parentMenuId, props.displaySidebar]);

  const handleMenuClick = (menuId, menuDetails) => {
    if (
      isMobile &&
      menuDetails &&
      menuDetails.SubMenu &&
      menuDetails.SubMenu.length
    ) {
      var tmpViewHeight = window.innerHeight + menuDetails.SubMenu.length * 38;
      setViewHeight(tmpViewHeight);
    }
  };

  const handleConfirm = () => {
    if (confirmBox.type === "Sitemap") {
      dispatch(commonAction.generateSiteMapAction({ businessID: user.businessId }));
    } else if (confirmBox.type === "MetaAds") {
      dispatch(generateMetaAdsAction.generateMetaAds({ businessID: user.businessId , device : 1 }));
    }

    // Close modal
    setConfirmBox({ ...confirmBox, show: false });
  };

  return (
    <div className="menu-sidebar p-0" style={{ minHeight: viewHeight }}>
      <Navbar.Brand className="d-block text-center sidebar-logo mb-2">
        <Image
          src={`${process.env.PUBLIC_URL}/images/logo.png`}
          className="logo-img"
        />
      </Navbar.Brand>
      <ListGroup className="rounded-0 sidebar-links bg-transparent">
        {permissionMenuList && permissionMenuList.length ? (
          permissionMenuList.map((menu, i) => (
            <div key={"menu-main-list-" + i}>
              {menu.DisplayInSideMenu && (
                <div key={"menu-list-" + i}>
                  {menu.SubMenu && menu.SubMenu.length ? (
                    <DropdownButton
                      as="li"
                      className={
                        "px2 py1  list-group-item gpnt-sidemnu parent-sidemenu " +
                        getNavLinkClass(menu.MenuId)
                      }
                      key={"sidemenu-" + menu.MenuId}
                      id={`dropdown-button-drop-${menu.MenuId}`}
                      drop="end"
                      onClick={handleMenuClick.bind(
                        "/admin" + menu.MenuId.toLowerCase(),
                        "/" +
                        menu.SubMenu[0].ParentId.toLowerCase() +
                        "/" +
                        menu.SubMenu[0].MenuId.toLowerCase(),
                        menu
                      )}
                      //onMouseOver={handleMenuOnMouseEnter}
                      menuid={menu.MenuId}
                      //onMouseLeave={handleMenuOnMouseLeave}
                      title={menu.Name}
                    >
                      {menu.SubMenu.map((subMenu, j) => (
                        <Dropdown.Item
                          as={NavLink}
                          //to={"/" + subMenu.ParentId + "/" + subMenu.MenuId}
                          to={`/admin/${subMenu.ParentId.toLowerCase()}/${subMenu.MenuId.toLowerCase()}${subMenu.HasSubMenu
                            ? `/${subMenu.SubMenu[0].MenuId.toLowerCase()}`
                            : ""
                            }`}
                          key={
                            "subMemnu-" + menu.MenuId + subMenu.MenuId + i + j
                          }
                        >
                          {subMenu.Name}
                        </Dropdown.Item>
                      ))}
                    </DropdownButton>
                  ) : (
                    <ListGroup.Item
                      as="li"
                      className={
                        "px2 py1 gpnt-sidemnu " +
                        getNavLinkClass("/admin/" + menu.MenuId.toLowerCase())
                      }
                    >
                      <NavLink
                        to={"/admin/" + menu.MenuId.toLowerCase()}
                        key={"sidemenu-" + menu.MenuId + i}
                      >
                        {menu.Name}
                      </NavLink>
                    </ListGroup.Item>
                  )}
                </div>
              )}
            </div>
          ))
        ) : (
          <></>
        )}
        <ListGroup.Item as="li" className={"px2 py1 gpnt-sidemnu"}
          disabled={gfun.Pending(stateCommon.geneateSiteMap)}
          onClick={() => setConfirmBox({ show: true, type: "Sitemap" })}>
          <span role="button">
            Generate Sitemap
          </span >
        </ListGroup.Item>
        <ListGroup.Item as="li"
          className={"px2 py1 gpnt-sidemnu"}
          disabled={gfun.Pending(stateGenerateMetaAds.generateMetaAds)}
          onClick={() => setConfirmBox({ show: true, type: "MetaAds" })}
        >
          <span role="button" >
            Generate Meta Site
          </span>
        </ListGroup.Item>

      </ListGroup>

      <ConfirmBox
        show={confirmBox.show}
        setShowConfirmBox={(show) => setConfirmBox({ ...confirmBox, show })}
        title="Confirm Action"
        message={
          confirmBox.type === "Sitemap"
            ? "Are you sure you want to generate sitemap?"
            : "Are you sure you want to generate Meta Site?"
        }
        onConfirmClick={handleConfirm}
      />
    </div>
  );
};

export default SidebarMenus;
